/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Exclusive_MessageInputs */

const en_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium is available exclusively in the Brave browser.`)
};

const id_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penelusuran Premium tersedia secara eksklusif di browser Brave.`)
};

const ms_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carian Premium tersedia secara eksklusif di penyemak imbas Brave.`)
};

const ca_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Cercador Premium només està disponible al navegador de Brave.`)
};

const cs_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium vyhledávač je k dispozici exkluzivně v prohlížeči Brave.`)
};

const da_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgning Premium er udelukkende tilgængelig i Brave-browseren.`)
};

const de_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium gibt es ausschließlich im Brave Browser.`)
};

const et_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasuline otsing on saadaval ainult Brave'i brauseris.`)
};

const es_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium está disponible exclusivamente en el navegador de Brave.`)
};

const fr_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La recherche Premium est disponible exclusivement dans le navigateur Brave.`)
};

const hr_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium tražilica dostupna je ekskluzivno u pregledniku Brave.`)
};

const it_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca Brave è disponibile esclusivamente nel browser di Brave.`)
};

const lv_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium ir pieejams tikai Brave pārlūkā.`)
};

const lt_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Premium“ paieška prieinama tik „Brave“ naršyklėje.`)
};

const hu_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Prémium előfizetés kizárólag a Brave böngészőben érhető el.`)
};

const nl_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium is exclusief beschikbaar in de Brave-browser.`)
};

const nb_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk Premium er kun tilgjengelig i Braves nettleser.`)
};

const pl_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwarka Search Premium jest dostępna wyłącznie w przeglądarce Brave.`)
};

const pt_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Pesquisa Premium está disponível exclusivamente no navegador Brave.`)
};

const ro_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium este disponibil exclusiv în browserul Brave.`)
};

const sk_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhľadávanie Premium je k dispozícii výlučne v prehliadači Brave.`)
};

const sl_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskanje Premium je na voljo izključno v brskalniku Brave.`)
};

const fi_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium on saatavilla ainoastaan Brave-selaimessa.`)
};

const sv_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök Premium finns endast i Brave-webbläsaren.`)
};

const vi_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm Premium chỉ có trên trình duyệt Brave.`)
};

const tr_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Arama yalnızca Brave tarayıcısında kullanılabilir.`)
};

const el_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Search Premium είναι διαθέσιμο αποκλειστικά στο πρόγραμμα περιήγησης Brave.`)
};

const bg_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене Premium се предлага изключително в браузъра Brave.`)
};

const ru_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск Премиум доступен исключительно в браузере Brave.`)
};

const sr_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium претрага је доступна искључиво у Brave прегледачу.`)
};

const uk_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium пошук доступний виключно у браузері Brave.`)
};

const ka_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium ექსკლუზიურად Brave ბრაუზერშია ხელმისაწვდომი.`)
};

const hi_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सर्च प्रीमियम केवल ब्रेव ब्राउज़र में उपलब्ध है।`)
};

const th_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium มีให้บริการเฉพาะในเบราว์เซอร์ Brave เท่านั้น`)
};

const ko_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 프리미엄은 Brave 브라우저에서만 사용할 수 있습니다.`)
};

const zh_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 Premium 仅在 Brave 浏览器中提供。`)
};

const zh_tw_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋高級版僅限於 Brave 瀏覽器中使用。`)
};

const ja_search_exclusive_message = /** @type {(inputs: Search_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search PremiumはBraveブラウザでのみ利用できます。`)
};

/**
* | output |
* | --- |
* | "Search Premium is available exclusively in the Brave browser." |
*
* @param {Search_Exclusive_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_exclusive_message = /** @type {((inputs?: Search_Exclusive_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Exclusive_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_exclusive_message(inputs)
	if (locale === "ms") return ms_search_exclusive_message(inputs)
	if (locale === "ca") return ca_search_exclusive_message(inputs)
	if (locale === "cs") return cs_search_exclusive_message(inputs)
	if (locale === "da") return da_search_exclusive_message(inputs)
	if (locale === "de") return de_search_exclusive_message(inputs)
	if (locale === "et") return et_search_exclusive_message(inputs)
	if (locale === "es") return es_search_exclusive_message(inputs)
	if (locale === "fr") return fr_search_exclusive_message(inputs)
	if (locale === "hr") return hr_search_exclusive_message(inputs)
	if (locale === "it") return it_search_exclusive_message(inputs)
	if (locale === "lv") return lv_search_exclusive_message(inputs)
	if (locale === "lt") return lt_search_exclusive_message(inputs)
	if (locale === "hu") return hu_search_exclusive_message(inputs)
	if (locale === "nl") return nl_search_exclusive_message(inputs)
	if (locale === "nb") return nb_search_exclusive_message(inputs)
	if (locale === "pl") return pl_search_exclusive_message(inputs)
	if (locale === "pt") return pt_search_exclusive_message(inputs)
	if (locale === "ro") return ro_search_exclusive_message(inputs)
	if (locale === "sk") return sk_search_exclusive_message(inputs)
	if (locale === "sl") return sl_search_exclusive_message(inputs)
	if (locale === "fi") return fi_search_exclusive_message(inputs)
	if (locale === "sv") return sv_search_exclusive_message(inputs)
	if (locale === "vi") return vi_search_exclusive_message(inputs)
	if (locale === "tr") return tr_search_exclusive_message(inputs)
	if (locale === "el") return el_search_exclusive_message(inputs)
	if (locale === "bg") return bg_search_exclusive_message(inputs)
	if (locale === "ru") return ru_search_exclusive_message(inputs)
	if (locale === "sr") return sr_search_exclusive_message(inputs)
	if (locale === "uk") return uk_search_exclusive_message(inputs)
	if (locale === "ka") return ka_search_exclusive_message(inputs)
	if (locale === "hi") return hi_search_exclusive_message(inputs)
	if (locale === "th") return th_search_exclusive_message(inputs)
	if (locale === "ko") return ko_search_exclusive_message(inputs)
	if (locale === "zh") return zh_search_exclusive_message(inputs)
	if (locale === "zh-tw") return zh_tw_search_exclusive_message(inputs)
	if (locale === "ja") return ja_search_exclusive_message(inputs)
	return en_search_exclusive_message(inputs)
});